import React from "react";
import Fade from "react-reveal/Fade";
import { Container1440Responsive } from "../common/global.styled";
import data from "../../data/contact.json";
import FooterContact from "../FooterContact";

const letterClass = "text-neutral-light-grey typo-body font-bold";
const textClass = "text-neutral-light-grey typo-body";
const DetailsDesktop = () => {
  return (
    <div className="w-full bg-blues-dark-blue">
      <Container1440Responsive className="pt-[90px] pb-[100px] grid grid-cols-[40%_60%] gap-y-[64px] border-b-[1px] border-background">
        <div className="pr-8 text-right">
          <Fade bottom>
            <p className="typo-h4 text-blues-light-blue">
              FOR LEASING
              <br />
              OPPORTUNITIES
            </p>
          </Fade>
        </div>
        <div className="text-neutral-light-grey typo-body pl-8">
          <Fade bottom delay={300}>
            <FooterContact
              textClass={textClass}
              letterClass={letterClass}
              {...data.leasing[0]}
            />
            {/* <FooterContact
              textClass={textClass}
              letterClass={letterClass}
              {...data.leasing[1]}
            /> */}
            <FooterContact
              textClass={textClass}
              letterClass={letterClass}
              {...data.leasing[2]}
            />
            <br />
            <FooterContact
              textClass={textClass}
              letterClass={letterClass}
              {...data.leasing[3]}
            />
          </Fade>
        </div>
        <div className="pr-8 text-right">
          <Fade bottom>
            <p className="typo-h4 text-blues-light-blue">
              BUILDING
              <br />
              OPERATION HOURS
            </p>
          </Fade>
        </div>
        <div className="text-neutral-light-grey typo-body pl-8">
          <Fade bottom delay={300}>
            <p>
              <b>Monday through Friday</b>
              <br /> 6am - 6pm
            </p>
            <br />
            <p>
              <b>Monday through friday</b>
              <br /> 6:00 pm - 6:00 am
              <br />
              Controlled access with security code in each floor
            </p>
            <br />
            <p>
              <b>Saturdays</b>
              <br /> 7am - 4pm
            </p>
          </Fade>
        </div>
      </Container1440Responsive>
    </div>
  );
};

export default DetailsDesktop;
